import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { isAwaitingFiltration } from 'src/routes/SearchPage/searchStatus/selectors';
import {
  hotelsVisibleLimitSelector,
  isVisibleShowMoreHotelsSelector,
} from '../../../../store/hotels/selectors';

import { setVisibleHotels } from '../../../../store/hotels/slice';

import { ShowMoreHotels } from './ShowMoreHotels';

const mapStateToProps = (state) => ({
  hotelsVisibleLimit: hotelsVisibleLimitSelector(state),
  isVisible: isVisibleShowMoreHotelsSelector(state),
  isAwaitingFiltration: isAwaitingFiltration(state),
});

const mapDispatchToProps = (dispatch) => ({
  setVisibleHotels: (count: number) => dispatch(setVisibleHotels(count)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ShowMoreHotels);
